import sendRequest from "../../../helpers/requestHelper";
import config from "../../../config";
import eventBus from "../../../event-bus/eventBus";

const getTodoTasks = {
    namespaced: true,
    state: {
        dataReceive: [],
        isLoadingTasks: false,
        latestTasks: [],
    },
    mutations: {
        GET_TASKS_FAILURE(state, error) {
            console.log(error);
        },
        GET_TASKS_SUCCESS(state, response) {
            state.dataReceive = response.data.data;
            eventBus.$emit("getTodoTasksSuccess", state.dataReceive);
        },
        GET_LATEST_TASKS_FAILURE(state, error) {
            console.log(error);
        },
        GET_LATEST_TASKS_SUCCESS(state, response) {
            state.latestTasks = response.data.data;
            eventBus.$emit("getLatestTodoTasksSuccess", state.latestTasks);
        }
    },
    actions: {
        getTodoTasks({dispatch, state}, projectId) {
            state.isLoadingTasks = true;
            let promise = sendRequest("get", config.baseURLApi + "/project-tasks/todo/" + projectId);
            promise.then(function(result) {
                if(result[0] === "success") {
                    dispatch("successGetTasks", result[1]);
                } else {
                    dispatch("failureGetTasks", result[1]);
                }
                state.isLoadingTasks = false;
            });
        },
        getLatestTasks({dispatch, state}) {
            state.isLoadingTasks = true;
            let promise = sendRequest("get", config.baseURLApi + "/project-tasks/latest");
            promise.then(function(result) {
                if(result[0] === "success") {
                    dispatch("successGetLatestTasks", result[1]);
                } else {
                    dispatch("failureGetLatestTasks", result[1]);
                }
                state.isLoadingTasks = false;
            });
        },
        successGetTasks({ commit }, response) {
            commit("GET_TASKS_SUCCESS", response);
        },
        failureGetTasks({ commit }, error) {
            commit("GET_TASKS_FAILURE", error);
        }, 
        successGetLatestTasks({ commit }, response) {
            commit("GET_LATEST_TASKS_SUCCESS", response);
        },
        failureGetLatestTasks({ commit }, error) {
            commit("GET_LATEST_TASKS_FAILURE", error);
        }
    }
}

export default getTodoTasks;